import { render } from "./DiscussionEditView.vue?vue&type=template&id=1f65a1a8"
import script from "./DiscussionEditView.vue?vue&type=script&lang=js"
export * from "./DiscussionEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__